(function() {
  'use strict';

  function ensureToastContainer() {
    var container = document.getElementById('cart-toast-container');
    if (container) return container;

    container = document.createElement('div');
    container.id = 'cart-toast-container';
    container.style.position = 'fixed';
    container.style.top = '1.5rem';
    container.style.right = '1.5rem';
    container.style.zIndex = '9999';
    container.style.pointerEvents = 'none';
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    container.style.gap = '0.5rem';

    document.body.appendChild(container);
    return container;
  }

  function showToast(message) {
    var container = ensureToastContainer();
    var toast = document.createElement('div');

    toast.className = 'cart-toast';
    toast.textContent = message || 'Added to cart';

    toast.style.backgroundColor = '#333';
    toast.style.color = '#fff';
    toast.style.padding = '0.75rem 1.25rem';
    toast.style.borderRadius = '4px';
    toast.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.25)';
    toast.style.fontSize = '0.9rem';
    toast.style.maxWidth = '260px';
    toast.style.pointerEvents = 'auto';
    toast.style.cursor = 'pointer';
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(-8px)';
    toast.style.transition = 'opacity 0.25s ease, transform 0.25s ease';

    container.appendChild(toast);

    // Trigger transition
    window.getComputedStyle(toast).opacity;
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';

    var hide = function() {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(-8px)';
      toast.addEventListener('transitionend', function handle() {
        toast.removeEventListener('transitionend', handle);
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      });
    };

    var timeoutId = window.setTimeout(hide, 3000);

    // Allow manual dismiss on click
    toast.addEventListener('click', function() {
      window.clearTimeout(timeoutId);
      hide();
    });
  }

  window.showCartToast = function(payload) {
    if (!payload) {
      showToast('Added to cart');
    } else if (typeof payload === 'string') {
      showToast(payload);
    } else if (payload && payload.title) {
      showToast('"' + payload.title + '" added to cart');
    } else {
      showToast('Added to cart');
    }
  };

  function hookShopifyOnItemAdded() {
    if (!window.Shopify || typeof Shopify.onItemAdded !== 'function') {
      return;
    }

    var originalOnItemAdded = Shopify.onItemAdded;
    Shopify.onItemAdded = function(lineItem) {
      if (typeof originalOnItemAdded === 'function') {
        originalOnItemAdded.apply(this, arguments);
      }
      window.showCartToast(lineItem);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hookShopifyOnItemAdded);
  } else {
    hookShopifyOnItemAdded();
  }
})();

